module.exports = __webpack_public_path__ + "static/img/exposure-mobile-4.0b86a2af.png";